import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { crossAnalysisTypes } from '../../../modules/analysis'

export const companiesAnalysisAxes = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readCompaniesAnalysisAxesSuccess(state, payload) {
      state.data = payload.data.map(axis => {
        const attributes = axis.attributes
        const crossAnalysisType = crossAnalysisTypes.find(type => type.fields === attributes.kind)

        // TODO 全ての分析にオリジナル分析軸が使えるようになったらcrossAnalysisTypesに、オリジナル分析軸5つを定義して以下を消す
        if (!crossAnalysisType) {
          return {
            id: attributes.kind,
            name: attributes.label,
            fields: attributes.kind,
            allName: i18n.t('models.analysis.crossAnalysisTypes.allName')
          }
        }

        return {
          ...crossAnalysisType,
          name: attributes.label,
          fields: attributes.kind,
        }
      })
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    readCompaniesAnalysisAxes({ commit, rootState }) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/analysis/axes.json')
        .then(res => {
          commit('readCompaniesAnalysisAxesSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
